export default "https://statics.cloudfastin.top/static/v1.27.31/store/images/ali.png?1349ece14586d3b9a42177839ceaf90e";